import { useNavigate } from 'react-router-dom';
import { Dialog as ShadcnDialog, DialogContent } from '@e2n/ui';
import { Suspense, useState } from 'react';
import { DialogContextProvider } from './DialogContext';
import { EditForm } from './EditForm';
import { useRouteParams } from './useRouteParams';
import { ConfirmDialog } from '../../components/ConfirmDialog';
import { FallbackDialogContent } from './FallbackDialogContent';

export function Dialog() {
  const navigate = useNavigate();
  const [hasFormUnsavedChanges, setHasFormUnsavedChanges] = useState(false);
  const [isConfirmDialogVisible, setIsConfirmDialogVisible] = useState(false);
  const { routeParams, searchParams } = useRouteParams();

  function onHandleClose(open: boolean) {
    if (!open && hasFormUnsavedChanges) {
      setIsConfirmDialogVisible(true);
    } else {
      navigate(
        `/controlling/umsatzplanung/${routeParams.jahr}/${routeParams.monat}`,
      );
    }
  }

  return (
    <>
      <ConfirmDialog
        open={isConfirmDialogVisible}
        onOpenChange={setIsConfirmDialogVisible}
        redirectTo={routeParams}
        type="planwerte"
      />
      <ShadcnDialog
        key="edit-planwerte-dialog"
        open={true}
        onOpenChange={onHandleClose}>
        <DialogContent className="sm:max-w-[1200px] px-8 py-0 gap-0">
          <Suspense fallback={<FallbackDialogContent />}>
            <DialogContextProvider key={searchParams.datum}>
              <EditForm setHasChanges={setHasFormUnsavedChanges} />
            </DialogContextProvider>
          </Suspense>
        </DialogContent>
      </ShadcnDialog>
    </>
  );
}
